import { render, staticRenderFns } from "./MeepIconOrganizationNew.vue?vue&type=template&id=654850d2"
import script from "./MeepIconOrganizationNew.vue?vue&type=script&lang=js"
export * from "./MeepIconOrganizationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports